import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
  SelectItem,
} from "../../../../Components/Items";

const { Option } = Select;

class AgregarTipoAcumulado extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "tiposAcumulados/agregarTipoAcumulado",
          {
            ...values,
            empresaId: this.props.empresaId,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Tipo de acumulado agregado exitosamente");
            this.cerrarModal();
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar el tipo de acumulado");
          } else {
            message.error("Sucedió un error y no se pudo agregar el tipo de acumulado");
          }
        })
        .catch(() => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre del tipo de acumulado");
    }
  }

  cerrarModal = () => {
    this.setState({ visible: false });
    this.props.cerrarAgregarTipoAcumulado();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Tipo de Acumulado"
        visible={this.state.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={600}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarTipoAcumulado"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="nombre"
            label="Nombre"
            required
            margin
          >
            <InputItem placeholder="Ingresa el nombre del tipo de acumulado" />
          </FormItem>

          <FormItem
            name="tipoAcumulado"
            label="Tipo de Acumulado"
            required
            margin
            initialValue={1}
          >
            <SelectItem placeholder="Selecciona el tipo de acumulado">
              <Option value={1}>Percepción, Deducción y Obligación</Option>
              <Option value={2}>Días y Horas</Option>
            </SelectItem>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarTipoAcumulado);